export default __webpack_public_path__ + "static/media/baby_duck.fd28a95c.png";